module.exports = "<div class=\"viewer\" m:on:click=\"onClick\">\n  <div m:show=\"html\" class=\"markdown-body\" m:html=\"html\"></div>\n  <div m:show=\"!html\" class=\"alert\" m:html=\"alert\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/viewer/index.html
// module id = 96
// module chunks = 0